import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom';

function ThankYou() {
    const location = useLocation();
    const navigate = useNavigate()

    useEffect(() => {
        if (location.state === null || location.state.moveThankYouPage === false) {
            navigate('/resume-builder');
        }
    }, []);

    return (
        <>
            <div className="d-flex justify-content-center align-items-center thank-you-page">
                <div className="col-xl-5 col-md-9 col-sm-10 m-2">
                    <div className="border border-3 border-success button-green"></div>
                    <div className="card  bg-white shadow p-5">
                        <div className="mb-4 text-center icon-section">
                            <svg xmlns="http://www.w3.org/2000/svg" className="bi bi-check-circle" width="75" height="75"
                                fill="currentColor" viewBox="0 0 16 16">
                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                <path
                                    d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                            </svg>
                        </div>
                        <div className="text-center ">
                            <h1>Thank You!</h1>
                            <p>Thank you for using the resume builder. If you’d like to create another resume, simply click the button below and enjoy the process once again.</p>
                            <Link to="/resume-builder"> <button className="btn btn-outline-success button-green mt-3">Create Your Resume</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ThankYou
